import React from "react"
import "./details.css"

function Details (){
    return (
        <div className=" Text">
            <h4>About Me </h4>
            <h2> Sentence </h2>
            <p>newbfjbvroucuroejncoeqrncoqnckwkdjsncuwrqncwoicincrjkwkldfmcnwqkcnrjcnjq 
                cwoqncrbcurbopuvowdjovqrwjdkjrvinioc    bvi vni rbi nvc o or ceubcruoebvq
                cbqvuq'vcbuqcb<br/>
                vc  'rvub'  <br/>
                vc  oubdooqdhuebob oubfpqpbfpqefr.
            </p>
            <h4>
                Career 
            </h4>
            <h2>Education and Experience</h2>
            <div>
            <dl className="Hori">
                <dd>May 2023-Present</dd>
                <dt>FreeLance Designer/Developer</dt>
                <dd>Date</dd>
                <dt>Internship</dt>
                <dd>Date</dd>
                <dt>Internship</dt>
                <dd>Date</dd>
                <dt>Internship</dt>
            </dl>
            </div>
            <h4>Services</h4>
            <h2>Expertise In</h2>
            <ul className="Services">
                <li><button className="buu">Designer</button></li>
                <li><button className="buu">Web Developer</button></li>
                <li><button className="buu">Flutter Development</button></li>
            </ul>
            <h4>Skills</h4>
            <h2>I am Great At</h2>
            <ul>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
                <li><img src="test/src/components/Profile/images/github.png" alt="" /></li>
            </ul>
        </div>
    );
}

export default Details;